import { render, staticRenderFns } from "./list-item-file-labtest.vue?vue&type=template&id=4ec87ab2"
import script from "./list-item-file-labtest.vue?vue&type=script&lang=js"
export * from "./list-item-file-labtest.vue?vue&type=script&lang=js"
import style0 from "./list-item-file-labtest.vue?vue&type=style&index=0&id=4ec87ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports